/**
 * Configuration & path resolution utilities.
 *
 * Centralises every piece of logic that answers the question
 * "where do I find resource X?" so the rest of the codebase
 * never has to care about context paths or global config objects.
 */

/**
 * Detect the application context path from a <meta> tag or the current URL.
 * @returns {string} e.g. "/myapp"
 */
export function getContextPath() {
    const meta = document.querySelector('meta[name="context-path"]');
    if (meta) return meta.getAttribute('content');

    const parts = window.location.pathname.split('/');
    return parts.length > 1 ? '/' + parts[1] : '';
}

/**
 * Prefix a relative path with the context path.
 * @param {string} path - e.g. "/css/bundled/bootstrap5.css"
 * @returns {string}
 */
export function rewritePath(path) {
    return getContextPath() + path;
}

/**
 * Resolve the list of CSS files to load inside the Shadow DOM.
 *
 * Priority order:
 *   1. `bs5-css` attribute on the host element (comma-separated)
 *   2. Global `window.BS5_CONFIG.cssFiles` array or `cssPath` string
 *
 * @param {HTMLElement} hostElement - the <next-htmx> element
 * @returns {string[]}
 */
export function getCSSFiles(hostElement) {
    // Priority 1: attribute
    const cssAttr = hostElement.getAttribute('bs5-css');
    if (cssAttr) {
        return cssAttr.split(',').map(p => p.trim());
    }

    // Priority 2: global config
    const config = window.BS5_CONFIG || {};
    if (Array.isArray(config.cssFiles)) return config.cssFiles;
    if (config.cssPath) return [config.cssPath];
}